// extracted by mini-css-extract-plugin
export default {"timerWrapper":"Timer_timerWrapper","timerWrapperIcon":"Timer_timerWrapperIcon","timer":"Timer_timer"};